function UserMenuSkeleton() {
  return (
    <div className="flex items-center">
      <div className="h-6 w-6 bg-gray-200 animate-pulse rounded me-1"></div>
      <div className="hidden md:block h-5 w-24 bg-gray-200 animate-pulse rounded"></div>
    </div>
  );
}

export default UserMenuSkeleton;